// import axios from "axios";

const BASE_URL = "https://flash-api-juir.onrender.com";
// const axiosInstance = axios.create({
//     baseURL: BASE_URL,
// })


export default BASE_URL;